/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgJournalAtribute = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path
          clipRule="evenodd"
          d="M15 2H2v20h14v-2H7V4h7.1a4.97 4.97 0 0 1 .9-2zm-.584 5H8v2h8a5.018 5.018 0 0 1-1.584-2zM5 4v16H4V4zm3 9h8v-2H8zm0 4h8v-2H8z"
          fillRule="evenodd"
        />
        <path d="M19 5c1.036 0 1.888-.984 1.99-2.245A3.001 3.001 0 0 1 20 7.83V22h-2V7.83a3.001 3.001 0 0 1-.99-5.075C17.112 4.015 17.964 5 19 5z" />
      </g>
    </g>
  </Icon>
);
export { SvgJournalAtribute as JournalAtribute };
